import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { FilterControl } from '../../../interfaces/filter-control';
import { FilterControlParams } from '../../../interfaces/filter-control-params';

@Component({
  selector: 'bm-number-filter',
  templateUrl: './number-filter.component.html',
  styleUrls: ['./number-filter.component.scss']
})
export class NumberFilterComponent implements FilterControl, OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() control: FilterControlParams;

  constructor() {}

  ngOnInit() {}

}
